class ModuleRedirectService {
    constructor() {
        this.accessTokenTimeOffset = 0;
        this.refreshTokenTimeOffset = 0;
    }

    static get MODULES() {
        return {
            BUSINESS: 'BUSINESS',
            DRIVER: 'DRIVER',
            CENTRAL: 'CENTRAL',
            CIVIC: 'CIVIC'
        };
    }

    redirect(user, module = undefined) {
        if (!user || !user.modules) {
            console.warn('No user or modules', user);
            return;
        }

        let paramsString = this.getParamString();
        let params = new URLSearchParams(paramsString);
        if (!module) {
            module = params.get('module') || user.modules?.[0];
        }

        let page = params.get('redirect');

        console.log('user modules', user.modules);
        console.log('url redirect module', module);
        let redirectTo;
        if (module && user.modules.includes(module)) {
            redirectTo = this.getModuleUrl(module);
        }

        console.warn(
            'Redirect to:',
            redirectTo,
            page,
            module,
            process.env.NODE_ENV
        );

        if (redirectTo) {
            if (page) {
                redirectTo += '#' + (page.charAt(0) !== '/' ? '/' : '') + page;
            }
            console.warn('Redirect to:', redirectTo);
            this.doRedirect(redirectTo);
        }
    }

    // location.href wrapped for testability
    doRedirect(url) {
        window.location.href = url;
    }

    // location.hash wrapped for testability
    getParamString() {
        if (location.href.indexOf('?') === -1) {
            return '';
        }
        let queryString = location.href.substr(location.href.indexOf('?') + 1);
        console.log(queryString);
        if (queryString.indexOf('#') > -1) {
            queryString = queryString.substr(0, queryString.indexOf('#'));
        }
        console.log('Returning paramString', queryString);
        return queryString;
    }

    getModuleUrl(module) {
        let prefix = process.env.VUE_APP_REDIRECT_PREFIX;
        console.log('getModuleUrl prefix', prefix);
        switch (module) {
            case ModuleRedirectService.MODULES.BUSINESS:
                return window.location.origin + prefix + 'business/';
            case ModuleRedirectService.MODULES.DRIVER:
                return window.location.origin + prefix + 'driver/';
            case ModuleRedirectService.MODULES.CENTRAL:
                return window.location.origin + prefix + 'central/';
            case ModuleRedirectService.MODULES.CIVIC:
                return window.location.origin + prefix + 'public/';
        }
        return null;
    }
}

export default ModuleRedirectService;
